import { render, staticRenderFns } from "./DraftTable.vue?vue&type=template&id=23a64b92&"
import script from "./DraftTable.vue?vue&type=script&lang=js&"
export * from "./DraftTable.vue?vue&type=script&lang=js&"
import style0 from "./DraftTable.vue?vue&type=style&index=0&id=23a64b92&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports